<template>
  <div>
    <div class="section-intro">
      <h2>{{ isFa ? 'سابقه دوره‌های درمان' : 'Care episode history' }}</h2>
      <p>{{ isFa ? 'وضعیت بسته‌شدن هر دوره از منبع سرور نمایش داده می‌شود.' : 'Closure state is shown from the server-authoritative episode record.' }}</p>
    </div>
    <p v-if="loading" class="empty">{{ isFa ? 'در حال دریافت…' : 'Loading…' }}</p>
    <div v-else-if="error" class="empty" role="alert">
      <p>{{ error }}</p>
      <button class="btn btn-secondary" @click="load(currentPage)">{{ isFa ? 'تلاش دوباره' : 'Try again' }}</button>
    </div>
    <p v-else-if="!episodes.length" class="empty">{{ isFa ? 'هنوز دوره‌ای ثبت نشده است.' : 'No care episodes are available yet.' }}</p>
    <article v-for="episode in episodes" :key="episode.id" class="card history-card">
      <div class="history-main">
        <strong>{{ isFa ? 'دوره درمان' : 'Care episode' }}</strong>
        <span class="code">{{ episode.id }}</span>
        <p>{{ labelState(episode.state) }}<span v-if="episode.close_reason"> · {{ labelReason(episode.close_reason) }}</span></p>
        <small v-if="episode.closed_at">{{ isFa ? 'بسته‌شده:' : 'Closed:' }} {{ episode.closed_at }}</small>
      </div>
      <div class="actions">
        <router-link class="btn btn-secondary" :to="closureLink(episode)">{{ isFa ? 'وضعیت پایان دوره' : 'Closure status' }}</router-link>
        <router-link class="btn btn-secondary" :to="letterLink(episode)">{{ isFa ? 'نامه خصوصی من' : 'My private letter' }}</router-link>
      </div>
    </article>
    <nav v-if="lastPage > 1" class="actions" :aria-label="isFa ? 'صفحه‌های سابقه' : 'History pages'">
      <button class="btn btn-secondary" :disabled="loading || currentPage <= 1" @click="load(currentPage - 1)">{{ isFa ? 'قبلی' : 'Previous' }}</button>
      <span aria-live="polite">{{ currentPage }} / {{ lastPage }}</span>
      <button class="btn btn-secondary" :disabled="loading || currentPage >= lastPage" @click="load(currentPage + 1)">{{ isFa ? 'بعدی' : 'Next' }}</button>
    </nav>
    <div class="actions">
      <router-link class="btn btn-primary" :to="r('portalProgress')">{{ isFa ? 'بازگشت به روند درمان' : 'Back to progress' }}</router-link>
    </div>
  </div>
</template>
<script>
import {clientMessage,clientError} from '@/intake/clientMessages'
import {fetchCareEpisodesHistory} from '@/intake/portalApi'
export default {
  name: 'PortalCareHistoryStep',
  data(){return{loading:true,error:'',episodes:[],currentPage:1,lastPage:1}},
  computed:{lang(){return this.$route.params.lang||'fa'},isFa(){return this.lang==='fa'}},
  mounted(){this.load()},
  methods:{clientMessage,
    r(name){return{name,params:{lang:this.lang}}},
    closureLink(e){return{name:'portalEpisodeClosure',params:{lang:this.lang,episodeId:e.id}}},
    letterLink(e){return{name:'portalEpisodeLetter',params:{lang:this.lang,episodeId:e.id}}},
    labelState(v){const map={ACTIVE:this.isFa?'فعال':'Active',CLOSED:this.isFa?'بسته':'Closed',REMATCH_PENDING:this.isFa?'در انتظار تعیین تکلیف بازتطبیق':'Rematch pending',REMATCHED:this.isFa?'بازتطبیق‌شده':'Rematched'};return map[v]||v||'—'},
    labelReason(v){const map={GOAL_MET:this.isFa?'هدف درمان محقق شده':'Goal met',DROPOUT:this.isFa?'پایان بدون تکمیل روند':'Dropout',TRANSFER:this.isFa?'انتقال':'Transfer',REMATCH:this.isFa?'بازتطبیق':'Rematch'};return map[v]||v||'—'},
    load(target=1){
      this.loading=true;this.error=''
      return fetchCareEpisodesHistory(target).then((page)=>{
        this.episodes=Array.isArray(page&&page.data)?page.data:[]
        this.currentPage=Number(page.current_page)||1
        this.lastPage=Number(page.last_page)||1
      }).catch(()=>{this.error=this.isFa?'دریافت سابقه انجام نشد. دوباره تلاش کنید.':'History could not be loaded. Please try again.'}).finally(()=>{this.loading=false})
    },
    reason(e){return clientError(e,this.lang)},
  },
}
</script>
<style scoped>
.history-card{margin-bottom:16px}.history-main{display:grid;gap:6px}.code{font-family:monospace;font-size:12px;overflow-wrap:anywhere}.actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:14px}
</style>
